import { Suspense } from 'react';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { MpItemZmsPage } from '@/features/marketPromotion/pages/MpItemZmsPage';
import { promoZmSearchSchema } from '@/features/promotion/types/promotion.types';
import { parsePositiveIdParams } from '@/utils/routeParams';

export const Route = createFileRoute('/_auth/market-promotion/adjustment/$promoItemId/')({
  parseParams: (rawParams) => {
    const params = parsePositiveIdParams(rawParams);
    if (params === null) throw notFound();
    return params;
  },
  validateSearch: promoZmSearchSchema,
  component: function MpItemZmsRoute() {
    const { promoItemId } = Route.useParams();
    const zmSearch = Route.useSearch();
    return (
      <ErrorBoundary moduleName="Market Promotion ZMs">
        <Suspense fallback={<PageLoader />}>
          <MpItemZmsPage promoItemId={promoItemId} zmSearch={zmSearch} />
        </Suspense>
      </ErrorBoundary>
    );
  },
});
